import { forwardRef } from 'react';
import { Link, LinkProps, useLocation } from 'react-router-dom';

import { useBackTargetForCurrentPage } from '@/context/transaction/useBackTargetForCurrentPage';

export const TransactionLink = forwardRef<HTMLAnchorElement, LinkProps>(({ state, ...props }, ref) => {
    const location = useLocation();
    const currentPageBackTarget = useBackTargetForCurrentPage();

    const backTarget = location.state?.transactionBackTarget ?? currentPageBackTarget;
    return <Link ref={ref} {...props} state={{ transactionBackTarget: backTarget, ...state }} />;
});

TransactionLink.displayName = 'TransactionLink';
